/**
 * Clés FR absentes de trTranslations — couverture 100 % pour la locale « tr ».
 * Valeurs EN par défaut (équivalent au repli i18next) ; à remplacer par des traductions natives.
 */
export const trGapTranslations: Record<string, string> = {};
